// src/pages/LoginPage.js
import React from 'react';
import { Box, Typography, Paper, Container, ThemeProvider } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { GoogleLogin } from '@react-oauth/google';

// Using the same dark theme as in HomePage
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#90caf9",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#fff",
      secondary: "#b0bec5",
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
    h4: {
      fontWeight: 700,
    },
  },
});

const LoginPage = () => {
  // Correctly use the useAuth hook to get authentication functions and state
  const { user, loading, isAuthorized, authError, signInWithGoogle } = useAuth();

  // If user is logged in and authorized, redirect to home page
  if (user && isAuthorized && !loading) {
    return <Navigate to="/" replace />;
  }

  // Handle successful Google login
  const handleGoogleSuccess = (credentialResponse) => {
    console.log("Google login success:", credentialResponse);
    // Call the handler from your auth context
    if (credentialResponse.credential) {
      signInWithGoogle(credentialResponse);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Container component="main" maxWidth="xs" sx={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
        <Paper 
          elevation={6}
          sx={{
            width: '100%',
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: 'background.paper',
          }}
        >
          <Typography component="h1" variant="h4" gutterBottom>
            Admin Console
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 2, color: 'text.secondary' }}>
            Sign in to access your dashboard
          </Typography>
          
          {authError && (
            <Typography 
              variant="body2" 
              color="error" 
              sx={{ 
                mb: 2, 
                p: 2, 
                bgcolor: 'rgba(211, 47, 47, 0.1)', 
                borderRadius: 1,
                width: '100%',
                textAlign: 'center'
              }}
            >
              {authError}
            </Typography>
          )}
          
          <Box sx={{ mt: 2, width: '100%' }}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => {
                console.log('Google Login Failed');
              }}
              useOneTap
              theme="filled_black"
              text="signin_with"
              shape="rectangular"
              width="100%"
            />
          </Box>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default LoginPage;